<template>
  <generic-modal :title="$t('purchase')" ref="generic_modal">
    <pre>{{ meta }}</pre>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <!-- <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button> -->
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "ViewPurchaseModal",
  components: { GenericModal },
  props: {
    // module_settings: {
    //   type: Object,
    //   required: true,
    // },
  },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      // let v = this;
      return false;
      // return v.pending > 0 /* || !v.meta.sale_price */;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(sale_uuid) {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
      if (sale_uuid) {
        get("/purchase", { uuid: sale_uuid })
          .then((response) => {
            v.meta = response;
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    save() {
      let v = this;

      post("/sale", v.meta)
        .then(() => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        // name: "",
        // barcode: "",
        // sale_price: "",
        // settings: {},
      };
      v.payment_methods = [];
      v.error = "";
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {
    is_form_invalid() {
      let v = this;
      v.buttons[0].disabled = v.is_form_invalid;
    },
  },
};
</script>
<style></style>
